import client from './client';

export default {
  /**
   * @param {Number} zipCode
   * @param {Function} cb
   */
  lookUp(zipCode, cb) {
    const req = client.request('get', `/zip_codes?zip_code=${zipCode}`);
    req.end(cb);
  },
};



// WEBPACK FOOTER //
// ./src/lib/zip_code.js